// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"671":"874267a5","874":"d764507d"}[chunkId] + ".chunk.js";
};